import Base from 'app/collections/base';
import { fulfillmentUrl } from 'utils/wrappers';
import FulfillmentOrder from 'app/models/fulfillment_order';

export default Base.extend({
  model: FulfillmentOrder,
  key: 'orders',
  url: fulfillmentUrl('orders'),

  initialize(models, { dateRange, apiModeSelection }) {
    this.dateRange = dateRange;
    this.apiModeSelection = apiModeSelection;
    this.listenTo(this.dateRange, 'change', this.reportFiltered);
    this.listenTo(this.apiModeSelection, 'change', this.reportFiltered);
  },

  reportFiltered() {
    this.trigger('filtered');
  },

  searchById(term) {
    if (!term || !term.trim()) {
      this.reset();
      this.trigger('sync');
      return;
    }

    // call fulfillment api, based on prefix to get by either warehouse id or
    const filterType = term.trim().split('_', 1)[0];
    const self = this;

    if (filterType === 'order') {
      new this.model({ id: term }).fetch({
        data: { ...this.apiModeSelection.getParams() },
        success(model) {
          self.reset([model]);
        },
        error() {
          self.reset();
          self.trigger('sync');
        },
      });

      return;
    }

    // assume tracking code
    this.fetch({ data: { query: term }});
  },

  paramsForFetch() {
    return {
      ...this.apiModeSelection.getParams(),
      ...this.dateRange.getParams(),
    };
  },

  parse(response) {
    this.hasMore = response[this.key].length === 10;
    return response[this.key];
  },
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_orders.js